import {  Directive, ElementRef } from '@angular/core';


import '../../src/assets/rl/jquery-1.8.1.min.js'
import '../../src/assets/rl/jquery.rotate.min.js'
import '../../src/assets/rl/fancybox/jquery.fancybox.js'


declare var $;

@Directive({
    selector: '[fancybox]'
})
export class FancyboxDirective {
    constructor(private _element: ElementRef) { } //private control: NgControl <--inject NgControl

        ngOnInit(){
            $('[fancybox]').fancybox({
                afterShow: function () {
                    
                    $('<div class="rotate0">0</div>').appendTo(this.inner).click(function () {
                        $('.fancybox-inner img').rotate({ animateTo: 0 })
                    });
                    $('<div class="rotate90">90</div>').appendTo(this.inner).click(function () {
                        $('.fancybox-inner img').rotate({ animateTo: 90 })
                    });
                    $('<div class="rotate180">180</div>').appendTo(this.inner).click(function () {
                        $('.fancybox-inner img').rotate({ animateTo: 180 })
                    });
                    $('<div class="rotate270">270</div>').appendTo(this.inner).click(function () {
                        $('.fancybox-inner img').rotate({ animateTo: 270 })
                    });
                },
                arrows : true,
                helpers: {
                    overlay: {
                        css: {
                            'background': 'rgba(0, 0, 0, 0.75)'
                        }
                    }
                }
            });
        }
}


